"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = require("react");

var arrays_1 = require("./arrays");

var is_1 = require("./is");

var REGISTERED_COMPONENTS = {};
exports.COMPONENT_NAMESPACE_KEY = '__BlueComponent__';
exports.CARD_TYPE = ['ArticleCard', 'Card'];
exports.CONTROL_TYPE = ['Button', 'CopyButton', 'Input', 'Input.AddOn', 'Select'];
exports.CHAT_TYPE = ['Message.Action', 'Message.Attachment', 'Message.Chat', 'Message.Content', 'Message.Embed', 'Message.Media', 'Message.Question'];
/**
 * Determines if a Component is a React component.
 *
 * @param   {React.Component} Component The component.
 * @returns {boolean} The result.
 */

exports.isReactComponent = function (Component) {
  return is_1.isObject(Component) && Component.hasOwnProperty('$$typeof') && Component.hasOwnProperty('type');
};
/**
 * Retrieves the internal Blue component namespace/key.
 *
 * @param   {React.Component} Component The component.
 * @returns {string} The namespace value.
 */


exports.getComponentName = function (Component) {
  if (exports.isReactComponent(Component)) {
    return Component.type[exports.COMPONENT_NAMESPACE_KEY];
  }

  return Component && Component[exports.COMPONENT_NAMESPACE_KEY];
};
/**
 * Retrieves a list of namespace registered Blue components.
 *
 * @returns {Array<string>} The registered namespaces.
 */


exports.getRegisteredComponents = function () {
  return Object.keys(REGISTERED_COMPONENTS).filter(function (key) {
    return key;
  });
};
/**
 * Secretly reset internal namespace registry.
 */


exports.__clearRegisteredComponents = function () {
  REGISTERED_COMPONENTS = {};
};
/**
 * Decorator (HOC) that sets the internal Blue component namespace/key.
 *
 * @param   {string} The namespace value.
 * @param   {React.Component} Component The component.
 * @returns {React.Component} The updated component.
 */


exports.namespaceComponent = function (key) {
  return function (Component) {
    /* istanbul ignore else */
    if (Component) {
      // Set the namespace.
      Component[exports.COMPONENT_NAMESPACE_KEY] = key; // Add to internal registry.

      REGISTERED_COMPONENTS[key] = true; // Conveniently set the displayName too.

      Component.displayName = key;
    }

    return Component;
  };
};

exports.isComponentNamespaced = function (Component) {
  return !!exports.getComponentName(Component);
};
/**
 * Determines if the internal Blue namespace matches a key.
 *
 * @param   {React.Component} Component The component.
 * @param   {string} The namespace value.
 * @returns {boolean} The match result.
 */


exports.isComponentNamed = function (Component, key) {
  return exports.getComponentName(Component) === key;
};
/**
 * Determines if the provided Component is a card type.
 *
 * @param   {React.Component} Component The component.
 * @returns {boolean} The result.
 */


exports.isComponentTypeCard = function (Component) {
  var key = exports.getComponentName(Component);
  return arrays_1.includes(exports.CARD_TYPE, key);
};
/**
 * Determines if the provided Component is a control type.
 *
 * @param   {React.Component} Component The component.
 * @returns {boolean} The result.
 */


exports.isComponentTypeControl = function (Component) {
  var key = exports.getComponentName(Component);
  return arrays_1.includes(exports.CONTROL_TYPE, key);
};
/**
 * Determines if the provided Component is a Chat type.
 *
 * @param   {React.Component} Component The component.
 * @returns {boolean} The result.
 */


exports.isComponentTypeChat = function (Component) {
  var key = exports.getComponentName(Component);
  return arrays_1.includes(exports.CHAT_TYPE, key);
};
/**
 * Attempts to retrieve a React key from a child when iterating.
 * @param   {React.Component} Component The component.
 * @param   {number | string} index The iterating index value.
 * @param   {string} fallback A fallback value.
 * @returns {string} The React cnild key.
 */


exports.getComponentKey = function (Component, index, fallback) {
  if (!exports.isReactComponent(Component) && !is_1.isObject(Component)) return undefined;
  var key;

  if (Component.props && Component.props.id) {
    key = Component.props.id;
  } else if (is_1.isDefined(fallback)) {
    key = fallback;
  } else if (is_1.isDefined(index)) {
    key = "unsafeComponentKey-" + index;
  } else {
    key = Component.key || undefined;
  }

  return key;
};

exports.renderRenderPropComponent = function (renderProp, props) {
  if (props === void 0) {
    props = {};
  }

  if (React.isValidElement(renderProp)) {
    return React.cloneElement(renderProp, props);
  }

  if (is_1.isFunction(renderProp)) {
    return renderProp(props);
  }

  return null;
};